import React, { FC } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { PaymentMethodForm } from "@modules/PaymentProcessing/Components/PaymentMethodForm/PaymentMethodForm";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import messages from "./messages";
import { PayByBankTransfer as CompanyOperations } from "./Adapters/CompanyOperations/PayByBankTransfer";
import { IOutlets } from "@Libs/Transclusion/types/outlets";

type Props = Omit<
  IOutlets["configure-payment.body"]["props"],
  "paymentMethod" | "basket"
> & { isAllowedPaymentMethodSingle?: boolean };

const PROVIDER_ADAPTERS = {
  company_operations: CompanyOperations,
};

export const PayByBankTransfer: FC<Props> = (props) => {
  const Adapter = PROVIDER_ADAPTERS["company_operations"];

  return (
    <PaymentMethodForm>
      <PaymentMethodForm.Header
        onChangeClick={props.onBack}
        paymentMethod={PaymentMethodType.BANK_TRANSFER}
        isAllowedPaymentMethodSingle={props.isAllowedPaymentMethodSingle}
      >
        <FormattedMessage {...messages.bankTransfer} />
      </PaymentMethodForm.Header>

      <PaymentMethodForm.Body>
        <Adapter {...props} />
      </PaymentMethodForm.Body>
    </PaymentMethodForm>
  );
};
